/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-primary2[_ngcontent-%COMP%]{color:#0067b8}.text-success2[_ngcontent-%COMP%]{color:#0f7c0f}.badge-success[_ngcontent-%COMP%]{background-color:#77b300}.badge-primary[_ngcontent-%COMP%]{background-color:#06a6f0}.badge-warning2[_ngcontent-%COMP%]{background-color:#ff533d;color:#fff}"];
export { styles as styles };
